import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    const wasLoggedOut = sessionStorage.getItem("wasLoggedOut");

    // If it's the root path or user just logged out, redirect to login
    if (location.pathname === "/" || wasLoggedOut) {
      if (wasLoggedOut) sessionStorage.removeItem("wasLoggedOut");
      return <Navigate to="/login" replace />;
    }

    // For local development, allow manual route bypass to emulate Angular behavior
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return <Outlet />;
    }

    // For any other direct route access (deep links) without being logged in, show the Not Found page
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;